import { useTranslations } from 'next-intl';
import { BrandLogo, Runtime } from '@silvertours/front-entities';

import { LogoWrapper } from './Logo.styles';

const Logo = () => {
  const { baseUrl } = Runtime.useHost();
  const { brandName } = Runtime.useBrand();
  const t = useTranslations('features.stageLegacy.stage.searchForm');

  return (
    <LogoWrapper>
      <span>{t('widget.poweredBy')}</span>
      <a
        href={`${baseUrl}/`}
        target="_blank"
        rel="noopener noreferrer nofollow"
        title={t('widget.logo.title')}
      >
        <BrandLogo brand={brandName} height="30" />
      </a>
    </LogoWrapper>
  );
};

export { Logo };
